import styled from 'styled-components'
import FormCheck from 'react-bootstrap/FormCheck'
import { FlexWrapper, Icon } from '../../../../components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const TableRow = styled.tr`
  vertical-align: baseline;
`

export const DatePickerWrapper = styled.div`
  .react-datepicker-wrapper {
    height: 45px;
  }
`

export const Switch = styled(FormCheck)`
  .form-check-input {
    width: 39px;
    height: 20px;
    margin-top: 8px;
  }
  .form-check-input:checked {
    background-color: ${({ theme }) => theme.switch.selected};
    border-color: ${({ theme }) => theme.switch.border};
    outline: ${({ theme }) => theme.switch.border};
  }
  .form-check-input:focus {
    box-shadow: none;
  }
`

interface StatusHandlerProps {
  onChangeHandler: () => void
  onSchedule: () => void
}

export const StatusHandler = ({
  onChangeHandler,
  onSchedule
}: StatusHandlerProps) => {
  return (
    <FlexWrapper noPadding>
      <Switch type="switch" id="custom-switch" onChange={onChangeHandler} />
      <Icon variant="outline-light" onClick={onSchedule}>
        <FontAwesomeIcon icon={['far', 'clock']} style={{ marginRight: 10 }} />
      </Icon>
    </FlexWrapper>
  )
}
